(function () {
  'use strict';

  const INITIALIZED_FLAG = '__countdownInited';

  function pad(num) {
    return String(num).padStart(2, '0');
  }

  function nextLocalMidnight() {
    const target = new Date();
    target.setHours(24, 0, 0, 0);
    return target;
  }

  function parseEndDate(value) {
    if (!value) return null;
    const date = new Date(value.replace(' ', 'T'));
    return isNaN(date.getTime()) ? null : date;
  }

  function startTimer(container) {
    if (container[INITIALIZED_FLAG]) return;
    container[INITIALIZED_FLAG] = true;

    const units = {
      days: container.querySelector('[data-unit="days"]'),
      hours: container.querySelector('[data-unit="hours"]'),
      minutes: container.querySelector('[data-unit="mins"]'),
      seconds: container.querySelector('[data-unit="seconds"]')
    };
    const fixedEnd = container.dataset.mode === 'date' ? parseEndDate(container.dataset.endDate) : null;
    let target = fixedEnd || nextLocalMidnight();
    let interval;

    function tick() {
      const now = new Date();
      if (now >= target) {
        if (fixedEnd) {
          clearInterval(interval);
          const block = container.closest('.countdown-timer-block');
          if (block) block.hidden = true;
          return;
        }
        target = nextLocalMidnight();
      }

      const total = Math.max(0, Math.floor((target - now) / 1000));
      if (units.days) units.days.textContent = pad(Math.floor(total / 86400));
      if (units.hours) units.hours.textContent = pad(Math.floor((total % 86400) / 3600));
      if (units.minutes) units.minutes.textContent = pad(Math.floor((total % 3600) / 60));
      if (units.seconds) units.seconds.textContent = pad(total % 60);
    }

    tick();
    interval = setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('.countdown-timer').forEach(startTimer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  }
})();
